import Field from "controls/Field";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useEnforceAuth from "hooks/useEnforceAuth";
import useShowMessage from "hooks/useShowMessage";
import TextInput from "inputs/TextInput";
import { Pencil } from "mdi-material-ui";
import React from "react";

export default function ChangePasswordDialog({ onSubmit, onClose }) {
  const changePassword = useActionFragment("changePassword");
  const showMessage = useShowMessage();
  const enforceAuth = useEnforceAuth();

  return (
    <FormDialog
      header="Change Password"
      onClose={onClose}
      onSubmit={async ({ newPassword, newPasswordConfirmation }) => {
        if (newPassword !== newPasswordConfirmation) {
          throw new Error("Passwords do not match");
        }
        await changePassword({ input: { newPassword } });
        await showMessage({
          header: "Password Changed",
          content: "Password changed successfully. You wil be prompted to login with the new password.",
          modal: true,
        });
        await enforceAuth.refetch();
        await onSubmit?.();
      }}
    >
      <Field
        label="New Password"
        name="newPassword"
        required
        input={<TextInput type="password" autoComplete="new-password" />}
      />
      <Field
        label="Confirm New Password"
        name="newPasswordConfirmation"
        required
        input={<TextInput type="password" autoComplete="new-password" />}
      />
    </FormDialog>
  );
}

ChangePasswordDialog.buttonProps = {
  icon: <Pencil />,
  content: "Change Password",
};
